import {CanMatchFn, UrlSegment} from '@angular/router';
import {SUPPORTED_APP_LANGUAGE_CODES} from '../shared/i18n/app-language';

export const isLocalizedLanguageSegment = (segment: UrlSegment | undefined): boolean => {
  if (!segment) {
    return false;
  }

  return SUPPORTED_APP_LANGUAGE_CODES.includes(segment.path.toLowerCase() as typeof SUPPORTED_APP_LANGUAGE_CODES[number]);
};

export const localizedLanguageRouteCanMatch: CanMatchFn = (_route, segments) => isLocalizedLanguageSegment(segments[0]);
